import { ImageHtmlProps, ObjectValues } from '../types';

export const aspectRatios = {
  square: 'cropped-image--square',
  twoThree: 'cropped-image--2-3',
  fourThree: 'cropped-image--4-3',
  threeTwo: 'cropped-image--3-2',
  threeFour: 'cropped-image--3-4',
  nineSixteen: 'cropped-image--9-16',
  nineEighteen: 'cropped-image--9-18',
  sixteenNine: 'cropped-image--16-9',
} as const;

export const loadings = {
  eager: 'eager',
  lazy: 'lazy',
} as const;

export type CroppedImage = ImageHtmlProps & {
  alt: string;
  aspectRatio?: ObjectValues<typeof aspectRatios>;
  className?: string;
  loading?: ObjectValues<typeof loadings>;
  src: string;
  srcQuery?: string;
};
